import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("h3", [_vm._v("重置密码")]), _c("el-form", {
    staticClass: "wlc-add-user",
    attrs: {
      "label-width": "80px",
      model: _vm.form
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "手机区号",
      required: ""
    }
  }, [_c("el-select", {
    model: {
      value: _vm.form.phonePrefixId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "phonePrefixId", $$v);
      },
      expression: "form.phonePrefixId"
    }
  }, _vm._l(_vm.phonePrefixList, function (item) {
    return _c("el-option", {
      key: item.index,
      attrs: {
        label: "".concat(item.prefix, " - ").concat(item.ch),
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "手机号",
      required: ""
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "phone", $$v);
      },
      expression: "form.phone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "密码",
      required: ""
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请填写密码（不低于8位）"
    },
    model: {
      value: _vm.form.password,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };